import { render, staticRenderFns } from "./SelezioneMultipla.vue?vue&type=template&id=205d5af7&scoped=true&"
import script from "./SelezioneMultipla.vue?vue&type=script&lang=js&"
export * from "./SelezioneMultipla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d5af7",
  null
  
)

export default component.exports